import React, { Component } from "react";
import PropTypes from 'prop-types';
import "../../styles/css/realTimeAI.scss";
import axios from 'axios';
import { Button, message } from "antd";
import { CELL_TYPE_TRANSLATION, CELL_TYPE_COLORS } from '../common/constants'; // 导入常量

const BASE64_PREFIX_REGEX = /^data:image\/(png|jpeg|gif);base64,/;
/**·
 * RealTimeAI组件用于实时AI分析
 * 该组件会根据AI开启状态定期获取并分析图像数据
 */
class RealTimeAI extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isRequesting: false,
        isStable: false,
        lastScreenshot: null,
        analysisResult: null,
        highlightedCell: null,
        isAIOpen: false,
    };
  }

  componentDidMount() {
    if (this.state.isAIOpen) {
        this.startMonitoring();
      } else {
        this.checkScreenshot(); // 初始检查
      }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isAIOpen !== this.state.isAIOpen) {
      if (this.state.isAIOpen) {
        this.startMonitoring();
      } else {
        this.stopMonitoring();
      }
    }
  }

  componentWillUnmount() {
    this.stopMonitoring();
  }

  /**
   * 开始监控图像变化
   */
  startMonitoring = () => {
    console.log('开始监控图像变化');
    this.setState({ timer: setInterval(this.checkScreenshot, 2000) });
  };

  /**
   * 停止监控图像变化
   */
  stopMonitoring = () => {
    console.log('停止监控图像变化');    
    clearInterval(this.state.timer);
    this.setState({ timer: null, lastScreenshot: null, lastChangeTime: null, isStable: false, isRequesting: false });
  };

  /**
   * 将base64编码的图像转换为ImageData对象
   * @param {string} base64 - base64编码的图像
   * @returns {Promise<ImageData>} ImageData对象
   */
 base64ToImageData = async (base64) => {
    return new Promise((resolve, reject) => {
         // 移除可能存在的前缀
         const base64Data = base64.replace(BASE64_PREFIX_REGEX, '');

         if (!base64Data) {
             return reject(new Error('Invalid Base64 string'));
         }

        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const imageData = ctx.getImageData(0, 0, img.width, img.height);
            console.log('ImageData from base64:', imageData); // 打印 ImageData 对象
            resolve(imageData);
        };
        img.onerror = (error) => {
            reject(new Error('Error loading image:', error));
        };
        img.src = base64;
    });
};


checkScreenshot = async () => {
  try {
      // 获取新的采样数据（直接使用灰度矩阵）
      const newSnapshot = await this.props.getImage20(); // 现在返回的是takeSnap20的对象
      
      // 验证数据结构
      if (!newSnapshot?.grayScaleMatrix || newSnapshot.grayScaleMatrix.length !== 100) {
          console.error('无效截图数据:', newSnapshot);
          return;
      }

      const { lastSnapshot, lastChangeTime, isRequesting } = this.state;
      
      // 首次运行初始化
      if (!lastSnapshot) {
          this.setState({ 
              lastSnapshot: newSnapshot,
              lastChangeTime: Date.now(),
              isStable: false 
          });
          return;
      }

      // 直接比较灰度矩阵（不再需要ImageData转换）
      let changedPoints = 0;
      const sensitivity = 10; // 灰度变化敏感度阈值
      
      // 并行遍历新旧矩阵
      newSnapshot.grayScaleMatrix.forEach(([newR], index) => {
          const [oldR] = lastSnapshot.grayScaleMatrix[index];
          if (Math.abs(newR - oldR) > sensitivity) {
              changedPoints++;
          }
      });

      // 计算变化百分比（基于100个采样点）
      const changePercentage = changedPoints;
      console.log(`变化点: ${changedPoints}/100 (${changePercentage}%)`);

      // 动态阈值策略
      const shouldUpdate = changedPoints > 19; // 超过30个变化点视为显著变化
      
      if (shouldUpdate) {
          console.log('检测到显著内容变化');
          // 取消未完成请求
          if (isRequesting) {
              clearTimeout(this.requestTimeout);
          }
          
          this.setState({ 
              lastSnapshot: newSnapshot,
              lastChangeTime: Date.now(),
              isStable: false,
              isRequesting: true 
          }, () => {
              this.sendForAnalysis();
          });
      } 
      // 稳定状态处理（1.5秒无显著变化）
      else if (Date.now() - lastChangeTime >= 1500) {
          if (!isRequesting) {
              console.log('进入稳定分析状态');
              this.setState({ 
                  isStable: true,
                  isRequesting: true 
              });
              
              this.sendForAnalysis();
          }
      }
  } catch (error) {
      console.error('检测流程异常:', error);
      this.setState({ isRequesting: false });
  }
};



sendForAnalysis = async () => {
  // 等待 takeSnapAll 返回的 Promise 解析
  const base64Image = await this.props.takeSnapAll();
    // 检查 base64Image 是否为字符串
    if (typeof base64Image !== 'string') {
      console.error('base64Image is not a string:', base64Image);
      return;
    }
   // 将 base64 字符串转换为 ImageData 对象
   const imageData = await this.base64ToImageData(base64Image);

   // 获取图片的宽度和高度
   const { width, height } = imageData;
   console.log('图片宽度:', width);
   console.log('图片高度:', height);
  // Basic Auth credentials
  const username = '99771a2d-f7c7-4311-a38c-eb0db8c54ff1';
  const password = '65d4e279-fbb3-4b3e-92ea-de98064d3df0';

  // API endpoint
  const url = 'https://tct.shensikao.com/api/v1/tct_dec';

  try {
    // 提取 Base64 数据部分
    const match = base64Image.match(BASE64_PREFIX_REGEX);
    if (!match) {
      console.error('Unexpected or unsupported base64 prefix');
      return;
    }
    const imageData = base64Image.substring(match[0].length);

    const formData = new FormData();
    formData.append('imageData', imageData);

    // Configure the request options
    const config = {
      method: 'post',
      url: url,
      headers: {
        'Authorization': `Basic ${Buffer.from(`${username}:${password}`).toString('base64')}`
      },
      withCredentials: false, // 确保不使用凭证
      data: formData // Your request payload
    };

    // Send the request
    const response = await axios(config);

    // Handle the response
    console.log('Image analysis successful:', response);
    this.props.drawCellAnnotations(response,width, height );

    // 更新状态
    this.setState(
      { analysisResult: response },
      () => message.success('图片分析完成') // 确保状态更新完成后显示成功消息
    );
  } catch (error) {
    console.error('Error during image analysis:', error.message);
    message.error('图片分析失败，请稍后再试');
  }
};

  /**
   * 计算细胞类型的数量
   * @param {Array} analysisResult - 分析结果
   * @returns {Array} 细胞类型及其数量的数组
   */
  getCellTypeCounts = (analysisResult) => {
    const cellCounts = {};

    analysisResult.forEach(item => {
      if (item.cells && item.cells.length > 0) {
        item.cells.forEach(cell => {
          try {
            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
            const cellType = CELL_TYPE_TRANSLATION[cell.names] || cell.names;

            if (cellCounts[cellType]) {
              cellCounts[cellType] += boxes.length;
            } else {
              cellCounts[cellType] = boxes.length;
            }
          } catch (e) {
            console.error('Error parsing cell boxes:', e);
          }
        });
      }
    });

    return Object.entries(cellCounts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };

  /**
   * 处理分析点击事件
   */
  handleAnalyzeClick = async () => {
    // 处理分析点击事件
  };

  /**
   * 切换AI开启状态
   */
  toggleAI = () => {
    this.setState(prevState => ({
      isAIOpen: !prevState.isAIOpen
    }));
  };

  render() {
    const {  enlargedImage, analysisResult } = this.state;

    return (
      <div className="RealTimeAIContainer" style={{ width: '100%' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', margin: '20px 0' }}>昕昱科技AI分析</h1>
        <hr style={{
          width: '100%',
          margin: '0 0 20px 0',
          border: 'none',
          borderTop: '1px solid #ccc',
          alignSelf: 'flex-start'
        }} />

        <div className="main-content" style={{
          display: 'flex',
          gap: '32px',
          justifyContent: 'space-between'
        }}>
          <div className="result-panel" style={{
            flex: 1,
            maxWidth: '100%',
            borderLeft: '1px solid #ccc',
            paddingLeft: '32px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <button 
                type="button" 
                onClick={this.toggleAI} 
                style={{ 
                  padding: '10px 20px', 
                  backgroundColor: this.state.isAIOpen ? '#f5222d' : '#0080ff', // 根据AI状态改变按钮颜色
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '4px', 
                  cursor: 'pointer' 
                }}
              >
                {this.state.isAIOpen ? '关闭AI' : '打开AI'}
              </button>
              <span style={{ fontSize: '14px', color: this.state.isAIOpen ? '#0080ff' : '#f5222d' }}> 
                AI开启状态： {this.state.isAIOpen ? 'AI开启中' : 'AI已关闭'}
              </span>
            </div>

            {
              analysisResult && (
                <div className="analysis-result" style={{
                  padding: '20px',
                  background: '#f5f5f5',
                  borderRadius: '4px',
                  height: '500px',
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ marginBottom: '16px' }}>
                    <h3 style={{ marginTop: 0, marginBottom: '8px' }}>分析结果:</h3>
                    <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666' }}>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>物镜倍数: </span>
                        <span>{analysisResult[0]?.file ? `${analysisResult[0].file}倍` : '未知'}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>图片质量: </span>
                        <span style={{ color: analysisResult[0]?.image_quality === 1 ? '#52c41a' : '#f5222d' }}>
                          {analysisResult[0]?.image_quality === 1 ? '清晰' : '不清晰'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{ flex: 1, overflowY: 'auto' }}>
                    <ul style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0
                    }}>
                      {analysisResult.map((item, itemIndex) => (
                        item.cells.map((cell, cellIndex) => {
                          try {
                            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
                            return boxes.map((box, boxIndex) => {
                              const uniqueId = `${itemIndex}-${cellIndex}-${boxIndex}`;
                              return (
                                <li
                                  key={uniqueId}
                                  style={{
                                    padding: '8px',
                                    margin: '4px 0',
                                    cursor: 'pointer',
                                    backgroundColor: this.state.highlightedCell === uniqueId ? '#e6f7ff' : 'transparent',
                                    borderLeft: this.state.highlightedCell === uniqueId ? '3px solid #1890ff' : 'none'
                                  }}
                                  onClick={() => {
                                    this.setState({ highlightedCell: uniqueId });
                                  }}
                                >
                                  {`${CELL_TYPE_TRANSLATION[cell.names] || cell.names} (${(box.confidence * 100).toFixed(1)}%)`}
                                </li>
                              );
                            });
                          } catch (e) {
                            console.error('Error parsing cell boxes:', e);
                            return null;
                          }
                        })
                      ))}
                    </ul>
                  </div>

                  <div style={{
                    marginTop: '16px',
                    paddingTop: '16px',
                    borderTop: '1px solid #e8e8e8'
                  }}>
                    <h4 style={{ marginBottom: '8px' }}>细胞分类统计:</h4>
                    <ul style={{
                      listStyleType: 'none',
                      padding: 0,
                      margin: 0,
                      fontSize: '14px'
                    }}>
                      {this.getCellTypeCounts(analysisResult).map((cellType, index) => (
                        <li key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                          <span>{cellType.name}:</span>
                          <span style={{ fontWeight: 'bold' }}>{cellType.count}个</span>
                        </li>
                      ))}
                    </ul>
                    <p style={{ marginTop: '8px', fontWeight: 'bold' }}>
                      总细胞数: {analysisResult.reduce((total, item) => {
                        return total + (item.cells ? item.cells.reduce((sum, cell) => {
                          try {
                            const boxes = JSON.parse(cell.boxes.replace(/'/g, '"'));
                            return sum + boxes.length;
                          } catch (e) {
                            return sum;
                          }
                        }, 0) : 0);
                      }, 0)}
                    </p>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

RealTimeAI.propTypes = {
  users: PropTypes.array.isRequired,
  getImage20: PropTypes.func.isRequired,
  takeSnapAll: PropTypes.func.isRequired,
  drawCellAnnotations: PropTypes.func.isRequired
};

export default RealTimeAI;